import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Dialog from "../../designSystem/c-organism/dialogs/Dialog";
import Tabs from "../../designSystem/b-molecules/tabs/Tabs";
import ManageBrands from "../customers/components/ManageBrands";
import ManageCountries from "../customers/components/ManageCountries";
import ManageLabels from "../settings/components/ManageLabels";
import { migrateBrandsCountries, checkMigrationNeeded } from "../../utils/migrateBrandsCountries";
import style from "./SettingsDialog.module.css";

const SettingsDialog = ({ show, onClose }) => {
  const org = useSelector((state) => state.orgStatus.value);
  const [activeTab, setActiveTab] = useState(0);
  const [migrationStatus, setMigrationStatus] = useState({
    checked: false,
    needsMigration: false,
    migrating: false
  });

  useEffect(() => {
    // Check if migration is needed on mount
    if (org?.payload) {
      checkMigrationNeeded(org.payload).then((status) => {
        setMigrationStatus({
          checked: true,
          needsMigration: status.needsMigration,
          migrating: false
        });
        
        // Auto-run migration if needed
        if (status.needsMigration) {
          handleMigration();
        }
      });
    }
  }, [org?.payload]);

  const handleMigration = async () => {
    if (!org?.payload || migrationStatus.migrating) return;
    
    setMigrationStatus(prev => ({ ...prev, migrating: true }));
    
    try {
      const result = await migrateBrandsCountries(org.payload);
      if (result.error) {
        console.error("Migration error:", result.error);
        alert(`Migration error: ${result.error}`);
      } else {
        setMigrationStatus({
          checked: true,
          needsMigration: false,
          migrating: false
        });
      }
    } catch (error) {
      console.error("Migration failed:", error);
      alert(`Migration failed: ${error.message}`);
      setMigrationStatus(prev => ({ ...prev, migrating: false }));
    }
  };

  const tabs = [
    { name: "Brands", selected: activeTab === 0, onClick: () => setActiveTab(0) },
    { name: "Countries", selected: activeTab === 1, onClick: () => setActiveTab(1) },
    { name: "Labels", selected: activeTab === 2, onClick: () => setActiveTab(2) }
  ];

  return (
    <Dialog
      show={show}
      onClose={onClose}
      title="Settings"
      variants={["large"]}
    >
      <div className={style.settingsContent}>
        {migrationStatus.migrating && (
          <div className={style.migrationNotice}>
            Migrating data... Please wait.
          </div>
        )}

        <Tabs tabs={tabs} />

        <div className={style.tabContent}>
          {activeTab === 0 && (
            <div className={style.manageContainer}>
              <ManageBrands inline={true} />
            </div>
          )}
          {activeTab === 1 && (
            <div className={style.manageContainer}>
              <ManageCountries inline={true} />
            </div>
          )}
          {activeTab === 2 && (
            <div className={style.manageContainer}>
              <ManageLabels inline={true} />
            </div>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default SettingsDialog;

